// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pz-0";
export var animationContainer = "_pz-1";
export var itemPrice = "_pz-a";
export var itemizedContent = "_pz-9";
export var itemizedHeader = "_pz-7";
export var itemizedRow = "_pz-8";
export var itemizedSection = "_pz-6";
export var modalContent = "_pz-2";
export var orderName = "_pz-3";
export var refundOption = "_pz-4";
export var refundOptionsContainer = "_pz-5";
export var shippingLabel = "_pz-b";
export var totalRow = "_pz-c";